import { render, staticRenderFns } from "./TableOperate.vue?vue&type=template&id=509944f2&scoped=true&"
import script from "./TableOperate.vue?vue&type=script&lang=js&"
export * from "./TableOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509944f2",
  null
  
)

export default component.exports